import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import Card from "../card"
import { P } from "../typography"

export const Banner = styled.div`
  background-color: ${({ theme }) => theme.colors.conversations.activeChat};
  padding: 1rem;
  border-radius: 0.5rem;
  height: fit-content;
`

export const BannerText = styled(P)`
  color: #333;
  margin: 0;
`

export const Container = styled.div`
  background-color: white;
  z-index: 10;

  ${breakpoint("tablet")`
    display: grid;
    grid-template-columns: 33% 1fr;
    height: 700px;
    border: 1px solid #D8D8D8;
  `}
`

export const List = styled.div`
  background-color: white;
  overflow-y: auto;
  display: none;
  border: 1px solid #d8d8d8;

  &::-webkit-scrollbar {
    width: 0.5rem;
    overflow: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
  }

  ${({ show }) =>
    !!show &&
    css`
      display: block;
    `}

  ${breakpoint("tablet")`
    display: block;
    border: none;
  `}
`

export const ListItem = styled.div`
  background-color: white;

  &:not(:first-child) {
    border-top: 1px solid #d8d8d8;
  }

  cursor: pointer;
  transition: 0.3s;
  padding: 1.25rem;
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;

  &:last-child {
    ${breakpoint("tablet")`
      border-bottom: 1px solid #D8D8D8;
    `}
  }

  ${breakpoint("tablet") &&
  css`
    ${({ selected }) =>
      !!selected &&
      css`
        background-color: ${({ theme }) => theme.colors.conversations.activeChat};
      `}

    &:hover, &:active {
      background-color: ${({ theme }) => theme.colors.conversations.activeChat};
    }
  `}
`

export const MessagesArea = styled.div`
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  height: -webkit-fill-available;
  width: 100vw;
  display: none;
  padding: 1rem;

  ${({ show }) =>
    !!show &&
    css`
      display: grid;
    `}

  ${breakpoint("tablet")`
    position: unset;
    top: unset;
    left: unset;
    height: unset;
    width: unset;
    display: grid;
    padding: 1.25rem;
    border-left: 1px solid #D8D8D8;
  `}

  ${({ selected }) =>
    !!selected &&
    css`
      gap: 1rem;
      place-content: start stretch;
      /* justify-content: space-between; */
      grid-template-rows: auto 1fr auto;
      overflow: hidden;
      box-sizing: border-box;
    `}

  ${({ selected }) =>
    !selected &&
    css`
      place-content: center;
    `}
`

export const Links = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;

  > :last-child {
    display: grid;
    grid-auto-flow: column;
    justify-items: end;
    gap: 1rem;
  }

  ${({ rescheduleInterviewEnabled }) =>
    !!rescheduleInterviewEnabled &&
    css`
      margin-bottom: 0;
    `}
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  text-decoration: underline;
  line-height: 1.4;
  cursor: pointer;
  display: block;

  &.back-to-messages {
    ${breakpoint("tablet")`
        display: none;
      }
    `}
  }
`

export const Messages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-right: 0.5rem;
  margin-right: -1rem;
  overflow-y: auto;

  // hide whilst loading and scrolling
  visibility: hidden;

  &::-webkit-scrollbar {
    width: 0.5rem;
    overflow: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.lightGrey};
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
    border-radius: 0.25rem;
  }

  ${breakpoint("tablet")`
    height: unset;
  `}
`

export const Message = styled.div`
  display: grid;
  gap: 0.25rem;
  max-width: 60%;
  place-self: flex-${({ align }) => align};
  margin-bottom: 1rem;
  white-space: pre-line;
  overflow-wrap: anywhere;
  justify-items: ${({ align }) => (align === "start" ? "start" : "end")};
`

export const Bubble = styled(Card)`
  padding: 0.75rem 1.25rem;
  margin: 0;
`

export const InputArea = styled.div`
  grid-template-columns: 1fr 25%;
  display: grid;
  align-items: end;
  gap: 0.5rem;

  button {
    height: 3rem;
    font-weight: 600;
  }

  ${breakpoint("tablet")`
    grid-template-columns: 1fr 20%;
  `}
`

export const MessageArea = styled.div`
  position: relative;

  p {
    position: absolute;
    right: 0;
    top: calc(100% + 1px);
  }
`

export const Counter = styled.span`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  min-height: 1.5rem;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
  font-size: 1rem;
  border-radius: 0.75rem;
`

export const Error = styled.span`
  color: ${({ theme }) => theme.colors.danger};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
`
